import React, { useState } from "react";
import {
  makeStyles,
  Button,
  Box,
  InputAdornment,
  Tabs,
  Tab,
  withStyles,
  FormControlLabel,
  Checkbox,
  Divider,
  Grid,
  MenuItem,
  Radio,
  TextField as TextField2,
} from "@material-ui/core";
import TitleText from "../components/reusableComponents/TitleText";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-material-ui";
import { setPayment } from "../reducers/UiReducer";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  FlightBookEtravDispatch,
  FlightBookDispatch,
  FlightTicketLCCDispatch,
  FlightAddBookingDispatch,
} from "../reducers/HomeReducer";
import { walletBalanceAgentDispatch } from "../reducers/UserReducer";
import ErrorModal from "../components/reusableComponents/ErrorModal";
import addBooking from "./FormAddBookingReturn";
import addBookingInt from "./FormAddBookingInt";
const title = ["Mr", "Mrs"];
const useStyles = makeStyles((theme) => ({
  selectField: {
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        border: "1px solid #959595",
      },
    },
    backgroundColor: "white",
    marginBottom: 30,
    width: "100%",
    marginTop: 10,
    borderRadius: 5,
    [theme.breakpoints.down("xs")]: {
      marginBottom: 15,
      marginTop: 8,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 5,
    },
    "& .css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root": {
      borderRadius: 5,
    },
  },
  InputPropsStyle: {
    backgroundColor: "white",
    borderRadius: 5,
  },
  inputPropsStyle: {
    padding: 14,
  },
  createButton: {
    backgroundColor: "rgb(239, 51, 57)",
    color: "white",
    borderRadius: 5,
    width: "100%",
    padding: "11px 8px",
    "&:hover": {
      backgroundColor: "rgb(239, 51, 57)",
    },
  },
  tabBorder: {
    borderBottom: "2px solid transparent",
    color: "#7B95AB",
    fontWeight: 400,
  },
  tabBorderColor: {
    borderBottom: "2px solid #313131",
    color: "#00325B",
    fontWeight: 700,
  },
  tab: {
    [theme.breakpoints.up("sm")]: {
      "& .MuiTab-root": {
        minWidth: 241,
        fontSize: 22,
      },
    },
  },
  date: {
    "& .MuiOutlinedInput-root": {
      borderRadius: 5,
      width: "100%",
    },
  },
  dob: {
    "& .MuiFormControl-root": {
      width: "100%",
    },
  },
  passport: {
    "& .MuiFormControl-root": {
      width: "100%",
    },
  },
  root: {
    "& .MuiFormHelperText-root": {
      fontSize: 12,
    },
    "& .MuiOutlinedInput-input": {
      fontSize: 14,
      padding: "13px 14px",
    },
    "& MuiInputLabel-root": {
      fontSize: 16,
    },
    "& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
      fontSize: 14,
    },
  },
  root2: {
    "& .MuiOutlinedInput-input": {
      fontSize: 14,
      padding: "13px 14px",
    },
    "& MuiInputLabel-root": {
      fontSize: 16,
    },
    "& .css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root": {
      fontSize: 14,
    },
  },
}));
const FlightConfirmReturnForm = ({ value }) => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();
  const [hold, setHold] = useState(false);
  const [pay, setPay] = useState(false);
  const { agentlogin, travellerlogin } = useSelector((state) => state.user);
  const { payment, etravflightFare } = useSelector((state) => state.ui);
  const { walletagent } = useSelector((state) => state.user);
  const { fareQuoteEtrav, fareQuote, onewayflightdata } = useSelector(
    (state) => state.home
  );
  const date = new Date();

  const getActualFormat = (given: number) => {
    if (given < 10) {
      return 0 + "" + given.toString();
    } else {
      return given;
    }
  };
  const invoice = [
    date.getFullYear(),
    getActualFormat(date.getMonth() + 1),
    getActualFormat(date.getDate()),
    getActualFormat(date.getHours()),
    getActualFormat(date.getMinutes()),
    getActualFormat(date.getSeconds()),
  ].join("");
  const [offline, setOffline] = useState(false);
  //   let agentInfo = {
  //     email: agentlogin && agentlogin.result.result.email,
  //     id: agentlogin && agentlogin.result.result.id,
  //   };
  let etrav2 = location.state.selectedonward
    ? location.state.selectedonward[0].Airline_Code &&
      location.state.selectedReturn[0].Airline_Code
    : "";
  let etrvotbor = location.state.selectedonward
    ? location.state.selectedonward[0].Airline_Code &&
      location.state.selectedReturn[0].AirlineCode
    : "";
  let etravrtboo = location.state.selectedonward
    ? location.state.selectedReturn[0].Airline_Code &&
      location.state.selectedonward[0].AirlineCode
    : "";
  let tbo2 = location.state.selectedonward
    ? location.state.selectedonward[0].AirlineCode &&
      location.state.selectedReturn[0].AirlineCode
    : "";
  const handlePayment = (response) => {
    if (location.state.selectedonward) {
      if (etrav2) {
        let formEtrav = {
          Customer_Mobile: location.state.formData.phone,
          Passenger_Mobile: location.state.formData.phone,
          orderId: location.state.orderID,
          paymentId:
            response === "success" ? invoice : response.razorpay_payment_id,
          WhatsAPP_Mobile: null,
          Passenger_Email: location.state.formData
            ? location.state.formData.email
            : "",
          PAX_Details: location.state.BookingData.map((item, index) => {
            return {
              Pax_Id: index + 1,
              Pax_type: item.PaxType - 1,
              Title: item.title,
              First_Name: item.first_name,
              Last_Name: item.last_name,
              Gender: 0,
              Age: null,
              DOB: item.dob,
              Passport_Number: null,
              Passport_Issuing_Country: null,
              Passport_Expiry: null,
              Nationality: null,
              FrequentFlyerDetails: null,
            };
          }),

          GST: true,
          GST_Number: "",
          GST_HolderName: "GST Holder Name",
          GST_Address: "GST Address",
          BookingFlightDetails: fareQuoteEtrav.result.AirRepriceResponses.map(
            (item) => {
              return {
                Search_Key: location.state.IDEtrav,
                Flight_Key: item.Flight.Flight_Key,
                BookingSSRDetails: [],
              };
            }
          ),
          CostCenterId: 0,
          ProjectId: 0,
          BookingRemark: `${location.state.returnBody.Segments[0].Origin}-${location.state.returnBody.Segments[0].Destination} ${location.state.returnBody.Segments[0].PreferredDepartureTime} ${invoice}`,
          CorporateStatus: 0,
          CorporatePaymentMode: 0,
          MissedSavingReason: null,
          CorpTripType: null,
          CorpTripSubType: null,
          TripRequestId: null,
          BookingAlertIds: null,
        };
        // console.log("first",formEtrav)
        dispatch(
          FlightBookEtravDispatch(
            formEtrav,
            history,
            payment,
            location.state,
            agentlogin
          )
        );
      } else if (tbo2) {
        if (location.state.selectedonward[0].IsLCC) {
          console.log("LCC");
          let formDataLCC = {
            TraceId: location.state.IDTBO,
            ResultIndex: location.state.selectedonward[0].ResultIndex,
            orderId: location.state.orderID,
            paymentId:
              response === "success" ? invoice : response.razorpay_payment_id,
            Passengers: location.state.BookingData.map((item) => {
              return {
                Title: item.title,
                FirstName: item.first_name,
                LastName: item.last_name,
                PaxType: item.PaxType,
                DateOfBirth: item.dob,
                Gender: 1,
                // PassportNo: location.state.formData
                // 	? location.state.formData.data.passport
                // 	: '',
                // PassportExpiry: '2023-12-06T00:00:00',
                AddressLine1: "hello",
                AddressLine2: "",
                Fare: {
                  Currency: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.Currency
                    : "",
                  BaseFare: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.OfferedFare
                    : "",
                  Tax: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.Tax
                    : "",
                  YQTax: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.YQTax
                    : "",
                  AdditionalTxnFeePub: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.AdditionalTxnFeePub
                    : "",
                  AdditionalTxnFeeOfrd: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.AdditionalTxnFeeOfrd
                    : "",
                  OtherCharges: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.OtherCharges
                    : "",
                  Discount: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.Discount
                    : "",
                  PublishedFare: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.PublishedFare
                    : "",
                  OfferedFare: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.OfferedFare
                    : "",
                  TdsOnCommission: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.TdsOnCommission
                    : "",
                  TdsOnPLB: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.TdsOnPLB
                    : "",
                  TdsOnIncentive: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.TdsOnIncentive
                    : "",
                  ServiceFee: location.state.selectedonward[0]
                    ? location.state.selectedonward[0].Fare.ServiceFee
                    : "",
                },
                City: "",
                CountryCode: "IN",
                CellCountryCode: "+91",
                ContactNo: location.state.formData
                  ? location.state.formData.phone
                  : "",
                Nationality: "IN",
                Email: location.state.formData
                  ? location.state.formData.email
                  : "",
                IsLeadPax: true,
                FFAirlineCode: null,
                FFNumber: "",
                GSTCompanyAddress: "",
                GSTCompanyContactNumber: "",
                GSTCompanyName: "",
                GSTNumber: "",
                GSTCompanyEmail: "",
              };
            }),
            Baggage: [],
            MealDynamic: [],
            SeatDynamic: [],
          };
          console.log("FormData", formDataLCC);
          dispatch(
            FlightTicketLCCDispatch(
              formDataLCC,
              history,
              location.state,
              agentlogin
            )
          );
        } else if (location.state.selectedonward[0].IsLCC === false) {
        }
        if (location.state.selectedReturn[0].IsLCC) {
          let formDataLCC = {
            TraceId: location.state.IDTBO,
            ResultIndex: location.state.selectedReturn[0].ResultIndex,
            orderId: location.state.orderID,
            paymentId:
              response === "success" ? invoice : response.razorpay_payment_id,
            Passengers: location.state.BookingData.map((item) => {
              return {
                Title: item.title,
                FirstName: item.first_name,
                LastName: item.last_name,
                PaxType: item.PaxType,
                DateOfBirth: item.dob,
                Gender: 1,
                // PassportNo: location.state.formData
                // 	? location.state.formData.data.passport
                // 	: '',
                // PassportExpiry: '2023-12-06T00:00:00',
                AddressLine1: "hello",
                AddressLine2: "",
                Fare: {
                  Currency: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.Currency
                    : "",
                  BaseFare: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.OfferedFare
                    : "",
                  Tax: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.Tax
                    : "",
                  YQTax: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.YQTax
                    : "",
                  AdditionalTxnFeePub: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.AdditionalTxnFeePub
                    : "",
                  AdditionalTxnFeeOfrd: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.AdditionalTxnFeeOfrd
                    : "",
                  OtherCharges: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.OtherCharges
                    : "",
                  Discount: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.Discount
                    : "",
                  PublishedFare: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.PublishedFare
                    : "",
                  OfferedFare: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.OfferedFare
                    : "",
                  TdsOnCommission: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.TdsOnCommission
                    : "",
                  TdsOnPLB: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.TdsOnPLB
                    : "",
                  TdsOnIncentive: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.TdsOnIncentive
                    : "",
                  ServiceFee: location.state.selectedReturn[0]
                    ? location.state.selectedReturn[0].Fare.ServiceFee
                    : "",
                },
                City: "",
                CountryCode: "IN",
                CellCountryCode: "+91",
                ContactNo: location.state.formData
                  ? location.state.formData.phone
                  : "",
                Nationality: "IN",
                Email: location.state.formData
                  ? location.state.formData.email
                  : "",
                IsLeadPax: true,
                FFAirlineCode: null,
                FFNumber: "",
                GSTCompanyAddress: "",
                GSTCompanyContactNumber: "",
                GSTCompanyName: "",
                GSTNumber: "",
                GSTCompanyEmail: "",
              };
            }),
            Baggage: [],
            MealDynamic: [],
            SeatDynamic: [],
          };
          console.log("FormData", formDataLCC);
          dispatch(
            FlightTicketLCCDispatch(
              formDataLCC,
              history,
              location.state,
              agentlogin
            )
          );
        } else if (location.state.selectedReturn[0].IsLCC === false) {
        }
      } else if (etrvotbor) {
        if (location.state.selectedonward[0].Airline_Code) {
          let formEtrav = {
            Customer_Mobile: location.state.formData.phone,
            Passenger_Mobile: location.state.formData.phone,
            orderId: location.state.orderID,
            paymentId:
              response === "success" ? invoice : response.razorpay_payment_id,
            WhatsAPP_Mobile: null,
            Passenger_Email: location.state.formData
              ? location.state.formData.email
              : "",
            PAX_Details: location.state.BookingData.map((item, index) => {
              return {
                Pax_Id: index + 1,
                Pax_type: item.PaxType - 1,
                Title: item.title,
                First_Name: item.first_name,
                Last_Name: item.last_name,
                Gender: 0,
                Age: null,
                DOB: item.dob,
                Passport_Number: null,
                Passport_Issuing_Country: null,
                Passport_Expiry: null,
                Nationality: null,
                FrequentFlyerDetails: null,
              };
            }),

            GST: true,
            GST_Number: "",
            GST_HolderName: "GST Holder Name",
            GST_Address: "GST Address",
            BookingFlightDetails: fareQuoteEtrav.result.AirRepriceResponses.map(
              (item) => {
                return {
                  Search_Key: location.state.IDEtrav,
                  Flight_Key: item.Flight.Flight_Key,
                  BookingSSRDetails: [],
                };
              }
            ),
            CostCenterId: 0,
            ProjectId: 0,
            BookingRemark: `${location.state.returnBody.Segments[0].Origin}-${location.state.returnBody.Segments[0].Destination} ${location.state.returnBody.Segments[0].PreferredDepartureTime} ${invoice}`,
            CorporateStatus: 0,
            CorporatePaymentMode: 0,
            MissedSavingReason: null,
            CorpTripType: null,
            CorpTripSubType: null,
            TripRequestId: null,
            BookingAlertIds: null,
          };
          // console.log("first",formEtrav)
          dispatch(
            FlightBookEtravDispatch(
              formEtrav,
              history,
              payment,
              location.state,
              agentlogin
            )
          );
        }
        if (location.state.selectedReturn[0].AirlineCode) {
          if (location.state.selectedReturn[0].IsLCC) {
            console.log("LCC");
            let formDataLCC = {
              TraceId: location.state.IDTBO,
              ResultIndex: location.state.selectedReturn[0].ResultIndex,
              orderId: location.state.orderID,
              paymentId:
                response === "success" ? invoice : response.razorpay_payment_id,
              Passengers: location.state.BookingData.map((item) => {
                return {
                  Title: item.title,
                  FirstName: item.first_name,
                  LastName: item.last_name,
                  PaxType: item.PaxType,
                  DateOfBirth: item.dob,
                  Gender: 1,
                  // PassportNo: location.state.formData
                  // 	? location.state.formData.data.passport
                  // 	: '',
                  // PassportExpiry: '2023-12-06T00:00:00',
                  AddressLine1: "hello",
                  AddressLine2: "",
                  Fare: {
                    Currency: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.Currency
                      : "",
                    BaseFare: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.OfferedFare
                      : "",
                    Tax: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.Tax
                      : "",
                    YQTax: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.YQTax
                      : "",
                    AdditionalTxnFeePub: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare
                          .AdditionalTxnFeePub
                      : "",
                    AdditionalTxnFeeOfrd: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare
                          .AdditionalTxnFeeOfrd
                      : "",
                    OtherCharges: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.OtherCharges
                      : "",
                    Discount: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.Discount
                      : "",
                    PublishedFare: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.PublishedFare
                      : "",
                    OfferedFare: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.OfferedFare
                      : "",
                    TdsOnCommission: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.TdsOnCommission
                      : "",
                    TdsOnPLB: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.TdsOnPLB
                      : "",
                    TdsOnIncentive: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.TdsOnIncentive
                      : "",
                    ServiceFee: location.state.selectedReturn[0]
                      ? location.state.selectedReturn[0].Fare.ServiceFee
                      : "",
                  },
                  City: "",
                  CountryCode: "IN",
                  CellCountryCode: "+91",
                  ContactNo: location.state.formData
                    ? location.state.formData.phone
                    : "",
                  Nationality: "IN",
                  Email: location.state.formData
                    ? location.state.formData.email
                    : "",
                  IsLeadPax: true,
                  FFAirlineCode: null,
                  FFNumber: "",
                  GSTCompanyAddress: "",
                  GSTCompanyContactNumber: "",
                  GSTCompanyName: "",
                  GSTNumber: "",
                  GSTCompanyEmail: "",
                };
              }),
              Baggage: [],
              MealDynamic: [],
              SeatDynamic: [],
            };
            console.log("FormData", formDataLCC);
            dispatch(
              FlightTicketLCCDispatch(
                formDataLCC,
                history,
                location.state,
                agentlogin
              )
            );
          } else if (location.state.selectedReturn[0].IsLCC === false) {
          }
        }
      } else if (etravrtboo) {
        if (location.state.selectedReturn[0].Airline_Code) {
          let formEtrav = {
            Customer_Mobile: location.state.formData.phone,
            Passenger_Mobile: location.state.formData.phone,
            orderId: location.state.orderID,
            paymentId:
              response === "success" ? invoice : response.razorpay_payment_id,
            WhatsAPP_Mobile: null,
            Passenger_Email: location.state.formData
              ? location.state.formData.email
              : "",
            PAX_Details: location.state.BookingData.map((item, index) => {
              return {
                Pax_Id: index + 1,
                Pax_type: item.PaxType - 1,
                Title: item.title,
                First_Name: item.first_name,
                Last_Name: item.last_name,
                Gender: 0,
                Age: null,
                DOB: item.dob,
                Passport_Number: null,
                Passport_Issuing_Country: null,
                Passport_Expiry: null,
                Nationality: null,
                FrequentFlyerDetails: null,
              };
            }),

            GST: true,
            GST_Number: "",
            GST_HolderName: "GST Holder Name",
            GST_Address: "GST Address",
            BookingFlightDetails: fareQuoteEtrav.result.AirRepriceResponses.map(
              (item) => {
                return {
                  Search_Key: location.state.IDEtrav,
                  Flight_Key: item.Flight.Flight_Key,
                  BookingSSRDetails: [],
                };
              }
            ),
            CostCenterId: 0,
            ProjectId: 0,
            BookingRemark: `${location.state.returnBody.Segments[0].Origin}-${location.state.returnBody.Segments[0].Destination} ${location.state.returnBody.Segments[0].PreferredDepartureTime} ${invoice}`,
            CorporateStatus: 0,
            CorporatePaymentMode: 0,
            MissedSavingReason: null,
            CorpTripType: null,
            CorpTripSubType: null,
            TripRequestId: null,
            BookingAlertIds: null,
          };
          // console.log("first",formEtrav)
          dispatch(
            FlightBookEtravDispatch(
              formEtrav,
              history,
              payment,
              location.state,
              agentlogin
            )
          );
        }
        if (location.state.selectedonward[0].AirlineCode) {
          if (location.state.selectedonward[0].IsLCC) {
            console.log("LCC");
            let formDataLCC = {
              TraceId: location.state.IDTBO,
              ResultIndex: location.state.selectedonward[0].ResultIndex,
              orderId: location.state.orderID,
              paymentId:
                response === "success" ? invoice : response.razorpay_payment_id,
              Passengers: location.state.BookingData.map((item) => {
                return {
                  Title: item.title,
                  FirstName: item.first_name,
                  LastName: item.last_name,
                  PaxType: item.PaxType,
                  DateOfBirth: item.dob,
                  Gender: 1,
                  // PassportNo: location.state.formData
                  // 	? location.state.formData.data.passport
                  // 	: '',
                  // PassportExpiry: '2023-12-06T00:00:00',
                  AddressLine1: "hello",
                  AddressLine2: "",
                  Fare: {
                    Currency: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.Currency
                      : "",
                    BaseFare: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.OfferedFare
                      : "",
                    Tax: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.Tax
                      : "",
                    YQTax: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.YQTax
                      : "",
                    AdditionalTxnFeePub: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare
                          .AdditionalTxnFeePub
                      : "",
                    AdditionalTxnFeeOfrd: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare
                          .AdditionalTxnFeeOfrd
                      : "",
                    OtherCharges: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.OtherCharges
                      : "",
                    Discount: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.Discount
                      : "",
                    PublishedFare: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.PublishedFare
                      : "",
                    OfferedFare: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.OfferedFare
                      : "",
                    TdsOnCommission: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.TdsOnCommission
                      : "",
                    TdsOnPLB: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.TdsOnPLB
                      : "",
                    TdsOnIncentive: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.TdsOnIncentive
                      : "",
                    ServiceFee: location.state.selectedonward[0]
                      ? location.state.selectedonward[0].Fare.ServiceFee
                      : "",
                  },
                  City: "",
                  CountryCode: "IN",
                  CellCountryCode: "+91",
                  ContactNo: location.state.formData
                    ? location.state.formData.phone
                    : "",
                  Nationality: "IN",
                  Email: location.state.formData
                    ? location.state.formData.email
                    : "",
                  IsLeadPax: true,
                  FFAirlineCode: null,
                  FFNumber: "",
                  GSTCompanyAddress: "",
                  GSTCompanyContactNumber: "",
                  GSTCompanyName: "",
                  GSTNumber: "",
                  GSTCompanyEmail: "",
                };
              }),
              Baggage: [],
              MealDynamic: [],
              SeatDynamic: [],
            };
            console.log("FormData", formDataLCC);
            dispatch(
              FlightTicketLCCDispatch(
                formDataLCC,
                history,
                location.state,
                agentlogin
              )
            );
          } else if (location.state.selectedonward[0].IsLCC === false) {
          }
        }
      }
    }
    if (location.state.intFlight) {
      console.log("first");
      if (location.state.intFlight.IsLCC) {
        console.log("LCC");
        let formDataLCC = {
          TraceId: location.state.IDTBO,
          ResultIndex: location.state.intFlight.ResultIndex,
          orderId: location.state.orderID,
          paymentId:
            response === "success" ? invoice : response.razorpay_payment_id,
          Passengers: location.state.BookingData.map((item) => {
            return {
              Title: item.title,
              FirstName: item.first_name,
              LastName: item.last_name,
              PaxType: item.PaxType,
              DateOfBirth: item.dob,
              Gender: 1,
              // PassportNo: location.state.formData
              // 	? location.state.formData.data.passport
              // 	: '',
              // PassportExpiry: '2023-12-06T00:00:00',
              AddressLine1: "hello",
              AddressLine2: "",
              Fare: {
                Currency: location.state.intFlight
                  ? location.state.intFlight.Fare.Currency
                  : "",
                BaseFare: location.state.intFlight
                  ? location.state.intFlight.Fare.OfferedFare
                  : "",
                Tax: location.state.intFlight
                  ? location.state.intFlight.Fare.Tax
                  : "",
                YQTax: location.state.intFlight
                  ? location.state.intFlight.Fare.YQTax
                  : "",
                AdditionalTxnFeePub: location.state.intFlight
                  ? location.state.intFlight.Fare.AdditionalTxnFeePub
                  : "",
                AdditionalTxnFeeOfrd: location.state.intFlight
                  ? location.state.intFlight.Fare.AdditionalTxnFeeOfrd
                  : "",
                OtherCharges: location.state.intFlight
                  ? location.state.intFlight.Fare.OtherCharges
                  : "",
                Discount: location.state.intFlight
                  ? location.state.intFlight.Fare.Discount
                  : "",
                PublishedFare: location.state.intFlight
                  ? location.state.intFlight.Fare.PublishedFare
                  : "",
                OfferedFare: location.state.intFlight
                  ? location.state.intFlight.Fare.OfferedFare
                  : "",
                TdsOnCommission: location.state.intFlight
                  ? location.state.intFlight.Fare.TdsOnCommission
                  : "",
                TdsOnPLB: location.state.intFlight
                  ? location.state.intFlight.Fare.TdsOnPLB
                  : "",
                TdsOnIncentive: location.state.intFlight
                  ? location.state.intFlight.Fare.TdsOnIncentive
                  : "",
                ServiceFee: location.state.intFlight
                  ? location.state.intFlight.Fare.ServiceFee
                  : "",
              },
              City: "",
              CountryCode: "IN",
              CellCountryCode: "+91",
              ContactNo: location.state.formData
                ? location.state.formData.phone
                : "",
              Nationality: "IN",
              Email: location.state.formData
                ? location.state.formData.email
                : "",
              IsLeadPax: true,
              FFAirlineCode: null,
              FFNumber: "",
              GSTCompanyAddress: "",
              GSTCompanyContactNumber: "",
              GSTCompanyName: "",
              GSTNumber: "",
              GSTCompanyEmail: "",
            };
          }),
          Baggage: [],
          MealDynamic: [],
          SeatDynamic: [],
        };
        console.log("FormData", formDataLCC);
        dispatch(
          FlightTicketLCCDispatch(
            formDataLCC,
            history,
            location.state,
            agentlogin
          )
        );
      } else if (location.state.intFlight.IsLCC === false) {
        let formData = {
          TraceId: location.state.IDTBO,
          ResultIndex: location.state.intFlight.ResultIndex,
          orderId: location.state.orderID,
          paymentId:
            response === "success" ? invoice : response.razorpay_payment_id,
          Passengers: location.state.BookingData.map((item) => {
            return {
              Title: item.title,
              FirstName: item.first_name,
              LastName: item.last_name,
              PaxType: item.PaxType,
              DateOfBirth: item.dob,
              Gender: 1,
              // PassportNo: location.state.formData
              // 	? location.state.formData.data.passport
              // 	: '',
              // PassportExpiry: '2023-12-06T00:00:00',
              AddressLine1: "hello",
              AddressLine2: "",
              Fare: {
                Currency: location.state.intFlight
                  ? location.state.intFlight.Fare.Currency
                  : "",
                BaseFare: location.state.intFlight
                  ? location.state.intFlight.Fare.OfferedFare
                  : "",
                Tax: location.state.intFlight
                  ? location.state.intFlight.Fare.Tax
                  : "",
                YQTax: location.state.intFlight
                  ? location.state.intFlight.Fare.YQTax
                  : "",
                AdditionalTxnFeePub: location.state.intFlight
                  ? location.state.intFlight.Fare.AdditionalTxnFeePub
                  : "",
                AdditionalTxnFeeOfrd: location.state.intFlight
                  ? location.state.intFlight.Fare.AdditionalTxnFeeOfrd
                  : "",
                OtherCharges: location.state.intFlight
                  ? location.state.intFlight.Fare.OtherCharges
                  : "",
                Discount: location.state.intFlight
                  ? location.state.intFlight.Fare.Discount
                  : "",
                PublishedFare: location.state.intFlight
                  ? location.state.intFlight.Fare.PublishedFare
                  : "",
                OfferedFare: location.state.intFlight
                  ? location.state.intFlight.Fare.OfferedFare
                  : "",
                TdsOnCommission: location.state.intFlight
                  ? location.state.intFlight.Fare.TdsOnCommission
                  : "",
                TdsOnPLB: location.state.intFlight
                  ? location.state.intFlight.Fare.TdsOnPLB
                  : "",
                TdsOnIncentive: location.state.intFlight
                  ? location.state.intFlight.Fare.TdsOnIncentive
                  : "",
                ServiceFee: location.state.intFlight
                  ? location.state.intFlight.Fare.ServiceFee
                  : "",
              },
              City: "",
              CountryCode: "IN",
              CellCountryCode: "+91",
              ContactNo: location.state.formData
                ? location.state.formData.phone
                : "",
              Nationality: "IN",
              Email: location.state.formData
                ? location.state.formData.email
                : "",
              IsLeadPax: true,
              FFAirlineCode: null,
              FFNumber: "",
              GSTCompanyAddress: "",
              GSTCompanyContactNumber: "",
              GSTCompanyName: "",
              GSTNumber: "",
              GSTCompanyEmail: "",
            };
          }),
          Baggage: [],
          MealDynamic: [],
          SeatDynamic: [],
        };
        dispatch(FlightBookDispatch(formData, history, location.state.IDTBO));
      }
    }
  };
  const PGCharge = 200;
  const payableAmout =
    location.state.intFlight?.Supplier === "TBO"
      ? Number(Math.round(location.state.intFlight.Fare.Total_Amount)) -
        Number(Math.round(location.state.intFlight.Fare.agentMarkup)) +
        Number(
          (Number(
            Number(Math.round(location.state.intFlight.Fare.Total_Amount)) -
              Number(Math.round(location.state.intFlight.Fare.agentMarkup))
          ) *
            2.5) /
            100
        )
      : Number(
		Number(
		  Math.round(
			location.state.selectedonward[0].Airline_Code
			  ? location.state.selectedonward[0].Fares
				  .Total_Amount
			  : location.state.selectedonward[0].Fare
				  .Total_Amount
		  )
		) +
		  Number(
			Math.round(
			  location.state.selectedReturn[0].Airline_Code
				? location.state.selectedReturn[0].Fares
					.Total_Amount
				: location.state.selectedReturn[0].Fare
					.Total_Amount
			)
		  )
	  );
  const handleFormSubmit = (data) => {
    const selectedFlight = 0;
    const priceDetails = fareQuoteEtrav
      ? fareQuoteEtrav.result.AirRepriceResponses[0]
      : fareQuote.result.Response;
    if (location.state.intFlight) {
      addBookingInt(
        location,
        agentlogin,
        payment,
        payableAmout,
        priceDetails,
        selectedFlight,
        dispatch,
        FlightAddBookingDispatch,
        PGCharge
      );
    } else {
      addBooking(
        location,
        agentlogin,
        payment,
        payableAmout,
        priceDetails,
        selectedFlight,
        dispatch,
        FlightAddBookingDispatch,
        PGCharge
      );
    }

    if (payment === "pay") {
      var options = {
        key: "rzp_test_1xufv8E9EKecYL",
        key_secret: "Ui7h6GeBLYxy1y75QaV6TgBz",
        // key: 'rzp_live_IZ3H2uQBdbxAbv',
        // key_secret: 'JVXsfYLHnTU4xk8uRGvmwZ2Q',
        amount: Number(Math.round(payableAmout)) * 100,

        currency: "INR",
        name: "Musafir Bazar",
        description: "for testing purpose",
        handler: handlePayment,
        prefill: {
          name: `${location.state.formData.first_name} ${location.state.formData.last_name}`,
          email: location.state.formData.email,
          contact: location.state.formData.phone,
        },
        notes: {
          address: location.state.formData.address,
        },
        theme: {
          color: "#3399cc",
        },
      };
      var pay = new window.Razorpay(options);
      pay.open();
    } else if (payment === "offline") {
      let res = "success";
      handlePayment(res);
    }
  };
  const handleHold = (e) => {
    if (e.target.value === "hold") {
      dispatch(setPayment(e.target.value));
      if (hold) {
        setPay(false);
        setOffline(false);
        setHold(false);
      } else {
        setHold(true);
        setPay(false);
        setOffline(false);
      }
    } else if (e.target.value === "pay") {
      dispatch(setPayment(e.target.value));
      if (pay) {
        setPay(false);
        setOffline(false);
        setHold(false);
      } else {
        setPay(true);
        setHold(false);
        setOffline(false);
      }
    } else if (e.target.value === "offline") {
      dispatch(setPayment(e.target.value));
      if (offline) {
        setPay(false);
        setHold(false);
        setOffline(false);
      } else {
        setPay(false);
        setHold(false);
        setOffline(true);
      }
    }
    console.log(e.target.value);
  };
  const edit = () => {
    history.push({
      pathname: "/summaryflight",
      state: {
        formData: location.state.formData,
        body: location.state.body,
        OneflightData: location.state.OneflightData,
      },
    });
  };
  return (
    <>
      <Formik
        initialValues={{
          email: location.state.formData.email,
          phone: location.state.formData.phone,
          titleA1: location.state.formData.titleA1,
          first_nameA1: location.state.formData.first_nameA1,
          last_nameA1: location.state.formData.last_nameA1,
          titleA2: location.state.formData.titleA2,
          first_nameA2: location.state.formData.first_nameA2,
          last_nameA2: location.state.formData.last_nameA2,
          titleA3: location.state.formData.titleA3,
          first_nameA3: location.state.formData.first_nameA3,
          last_nameA3: location.state.formData.last_nameA3,
          titleA4: location.state.formData.titleA4,
          first_nameA4: location.state.formData.first_nameA4,
          last_nameA4: location.state.formData.last_nameA4,
          titleA5: location.state.formData.titleA5,
          first_nameA5: location.state.formData.first_nameA5,
          last_nameA5: location.state.formData.last_nameA5,
          titleA6: location.state.formData.titleA6,
          first_nameA6: location.state.formData.first_nameA6,
          last_nameA6: location.state.formData.last_nameA6,
          titleA7: location.state.formData.titleA7,
          first_nameA7: location.state.formData.first_nameA7,
          last_nameA7: location.state.formData.last_nameA7,
          titleA8: location.state.formData.titleA8,
          first_nameA8: location.state.formData.first_nameA8,
          last_nameA8: location.state.formData.last_nameA8,
          titleC1: location.state.formData.titleC1,
          first_nameC1: location.state.formData.first_nameC1,
          last_nameC1: location.state.formData.last_nameC1,
          titleC2: location.state.formData.titleC2,
          first_nameC2: location.state.formData.first_nameC2,
          last_nameC2: location.state.formData.last_nameC2,
          titleC3: location.state.formData.titleC3,
          first_nameC3: location.state.formData.first_nameC3,
          last_nameC3: location.state.formData.last_nameC3,
          titleC4: location.state.formData.titleC4,
          first_nameC4: location.state.formData.first_nameC4,
          last_nameC4: location.state.formData.last_nameC4,
          titleC5: location.state.formData.titleC5,
          first_nameC5: location.state.formData.first_nameC5,
          last_nameC5: location.state.formData.last_nameC5,
          titleC6: location.state.formData.titleC6,
          first_nameC6: location.state.formData.first_nameC6,
          last_nameC6: location.state.formData.last_nameC6,
        }}
        validate={(values) => {
          const errors = {};

          return errors;
        }}
        onSubmit={handleFormSubmit}
      >
        {({ submitForm, isSubmitting, values, errors }) => (
          <>
            {" "}
            <Form>
              {/* Email and PhoneNumber Section */}
              <Box
                className={classes.root}
                style={{
                  background: "white",
                  padding: "10px 15px",
                  border: "1px solid #e6e6e6",
                  marginTop: "10px",
                  boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                  borderRadius: "5px",
                }}
              >
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  style={{ marginTop: 20, alignItems: "baseline" }}
                >
                  <Grid item xs={12} lg={6}>
                    <Field
                      component={TextField}
                      name="email"
                      type="email"
                      disabled
                      variant="outlined"
                      label="Email ID"
                      className={classes.selectField}
                      InputProps={{
                        className: classes.InputPropsStyle,
                      }}
                      inputProps={{
                        style: { padding: 12 },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <Field
                      component={TextField}
                      name="phone"
                      type="number"
                      disabled
                      variant="outlined"
                      error={errors.phone}
                      label="Mobile No."
                      className={classes.selectField}
                      InputProps={{
                        className: classes.InputPropsStyle,
                      }}
                      inputProps={{
                        style: { padding: 12 },
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
              {/* for adult 1 */}
              {location.state.returnBody.AdultCount === 1 && (
                <Box
                  className={classes.root}
                  style={{
                    background: "white",
                    padding: "10px 15px",
                    border: "1px solid #e6e6e6",
                    marginTop: "10px",
                    boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                    borderRadius: "5px",
                  }}
                >
                  <Box display="flex">
                    <TitleText three textStyle={{ marginTop: 10 }}>
                      1
                    </TitleText>
                    <TitleText
                      three
                      textStyle={{ marginLeft: 5, marginTop: 10 }}
                    >
                      Adult
                    </TitleText>
                  </Box>
                  <Grid
                    container
                    spacing={2}
                    alignItems="center"
                    style={{ marginTop: 20, alignItems: "baseline" }}
                  >
                    <Grid
                      item
                      xs={12}
                      sm={6}
                      lg={4}
                      className={classes.root2}
                      style={{ alignItems: "center" }}
                    >
                      <Field
                        component={TextField}
                        select
                        name="titleA1"
                        type="text"
                        variant="outlined"
                        disabled
                        label="Select Title"
                        error={errors.titleA1}
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          className: classes.inputPropsStyle,
                        }}
                      >
                        {title.map((item, index) => (
                          <MenuItem key={index} value={item}>
                            {item}
                          </MenuItem>
                        ))}
                      </Field>
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="first_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter First Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} lg={4}>
                      <Field
                        component={TextField}
                        name="last_nameA1"
                        type="text"
                        disabled
                        variant="outlined"
                        label="Enter Last Name"
                        className={classes.selectField}
                        InputProps={{
                          className: classes.InputPropsStyle,
                        }}
                        inputProps={{
                          style: { padding: 12 },
                        }}
                      />
                    </Grid>
                  </Grid>
                </Box>
              )}
              {/* payment method */}
              <Box
                alignItems="center"
                display="flex"
                style={{
                  background: "white",
                  padding: "10px 15px",
                  border: "1px solid #e6e6e6",
                  marginTop: "10px",
                  boxShadow: "0 0.5rem 1rem rgb(0 0 0 / 15%)",
                  borderRadius: "5px",
                }}
              >
                {agentlogin &&
                agentlogin.result &&
                agentlogin.result.result &&
                agentlogin.result.result.role === "Agent" ? (
                  <>
                    <FormControlLabel
                      style={{ marginRight: 0 }}
                      value="offline"
                      control={
                        <Radio
                          checked={offline}
                          onClick={handleHold}
                          disabled={
                            etrav2
                              ? Number(
                                  Number(
                                    Math.round(
                                      location.state.selectedReturn[0].Fares
                                        .Total_Amount
                                    )
                                  ) +
                                    Number(
                                      Math.round(
                                        location.state.selectedonward[0].Fares
                                          .Total_Amount
                                      )
                                    )
                                ) <
                                Number(
                                  Math.round(
                                    walletagent &&
                                      walletagent.result.balanceAmount
                                  )
                                )
                                ? false
                                : true
                              : tbo2
                              ? Number(
                                  Number(
                                    Math.round(
                                      location.state.selectedReturn[0].Fare
                                        .Total_Amount
                                    )
                                  ) +
                                    Number(
                                      Math.round(
                                        location.state.selectedonward[0].Fare
                                          .Total_Amount
                                      )
                                    )
                                ) <
                                Number(
                                  Math.round(
                                    walletagent &&
                                      walletagent.result.balanceAmount
                                  )
                                )
                                ? false
                                : true
                              : ""
                          }
                        />
                      }
                    />
                    <span>Offline Amount</span>
                    <span style={{ marginLeft: 5, color: "blue" }}>
                      {" "}
                      {etrav2
                        ? Number(
                            Number(
                              Math.round(
                                location.state.selectedReturn[0].Fares
                                  .Total_Amount
                              )
                            ) +
                              Number(
                                Math.round(
                                  location.state.selectedonward[0].Fares
                                    .Total_Amount
                                )
                              )
                          )
                        : tbo2
                        ? Number(
                            Number(
                              Math.round(
                                location.state.selectedReturn[0].Fare
                                  .Total_Amount
                              )
                            ) +
                              Number(
                                Math.round(
                                  location.state.selectedonward[0].Fare
                                    .Total_Amount
                                )
                              )
                          )
                        : ""}
                    </span>
                    {/* <FormControlLabel
											style={{ marginRight: 0, marginLeft: 10 }}
											value='hold'
											control={
												<Radio
													checked={hold}
													onClick={handleHold}
													style={{ marginLeft: 10 }}
												/>
											}
											// label='Hold'
										/>
										<span>Hold</span> */}
                  </>
                ) : (
                  ""
                )}

                <FormControlLabel
                  style={{ marginRight: 0, marginLeft: 10 }}
                  value="pay"
                  control={
                    <Radio
                      checked={pay}
                      onClick={handleHold}
                      style={{ marginLeft: 10 }}
                    />
                  }
                  // label='Pay Online'
                />
                <span>Pay Online</span>
                <span style={{ marginLeft: 5, color: "blue" }}> </span>
              </Box>
              {/* Submit and Edit Button */}
              <Grid container spacing={2}>
                <Grid item xs={4} lg={2}>
                  <Button
                    className={classes.createButton}
                    onClick={edit}
                    style={{ marginTop: 10, fontSize: 14 }}
                    // disabled={isSubmitting}
                  >
                    EDIT
                  </Button>
                </Grid>
                <Grid item xs={8} lg={4}>
                  <Button
                    className={classes.createButton}
                    onClick={handleFormSubmit}
                    style={{ marginTop: 10, fontSize: 14 }}
                    // disabled={isSubmitting}
                  >
                    PROCESS TO PAYMENT
                  </Button>
                </Grid>
                <Grid item xs={4}></Grid>
              </Grid>
            </Form>
          </>
        )}
      </Formik>
      <ErrorModal />
    </>
  );
};

export default FlightConfirmReturnForm;
